import React from 'react';

interface ExamPageHeaderItemDatamodel {
  headline: string;
  content: string;
  image: string | JSX.Element; // Modified to accept either string or JSX element
}
export const SessionHeaderItem: React.FC<ExamPageHeaderItemDatamodel> = ({
  headline,
  content,
  image,
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
    <label style={{ fontWeight: 'initial', fontSize: '16px' }}>
      {headline}
    </label>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      {typeof image === 'string' ? <img src={image} height={24} /> : image}{' '}
      <label style={{ fontWeight: 'bold', fontSize: '24px' }}>{content}</label>
    </div>
  </div>
);
